import React from "react";
import { graphql } from "gatsby";
import Header from "../components/header";
import Github from "../Assets/svg/github.svg";
import Website from "../Assets/svg/globe.svg";
import * as styles from "./projects.module.css";

const Project = ({ data }) => {
  return (
    <div className={styles.card}>
      <div style={{ padding: "7px" }}>
        <h3
          style={{
            borderBottom: "5px solid #023E8A",
            width: "max-content",
            paddingBottom: "5px",
            marginBottom: "7px",
          }}
        >
          {data.name}
        </h3>
        <p className={styles.desc}>{data.shortDescription}</p>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
          }}
        >
          <div className={styles.date}>{data.year}</div>
          <div>
            <a href={data.github} target="blank">
              <img src={Github} className={styles.icon} />
            </a>
            <a href={data.landingPage} target="blank">
              <img src={Website} className={styles.icon} />
            </a>
          </div>
        </div>
        <div className={styles.containerImage}>
          <img className={styles.image} src={data.image} />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            justifySelf: "center",
          }}
        >
          <div className={styles.tag}>{data.year}</div>
        </div>
      </div>
    </div>
  );
};

export default function Projects({ data }) {
  console.log("hello", data);
  return (
    <div>
      <Header headerText="About React" />
      <div className={styles.cardsOuter}>
        {" "}
        {data.allMarkdownRemark.edges.map(value => (
          <Project data={value.node.frontmatter}></Project>
        ))}
      </div>
    </div>
  );
}

export const query = graphql`
  query {
    allMarkdownRemark(filter: { fileAbsolutePath: { regex: "//projects//" } }) {
      edges {
        node {
          frontmatter {
            name
            image
            shortDescription
            year
            github
            landingPage
          }
        }
      }
    }
  }
`;
